export default __webpack_public_path__ + "static/media/youtube-hover.9915e2a4.svg";